import {
  BrowserRouter,
  Navigate,
  Route,
  Routes,
  useLocation,
  useNavigate,
} from "react-router-dom";
import { setMiniSidenav, useMaterialUIController } from "./context";
import { useEffect, useState } from "react";
import { CssBaseline, ThemeProvider } from "@mui/material";
import theme from "./assest/theme";
import Sidenav from "./layoutcontainers/DashboardLayout/components/Sidebar";
import routes from "./routes";
import logo from "../src/assest/images/InsurelogistLogo.png";

import "./index.css";
import { useLoading } from "./components/Loading";
import Spinner from "./components/Spinner";
import { setNavigator } from "./services/navigate";

function App() {
  const [controller, dispatch] = useMaterialUIController();
  const { circleLoading, setCircleLoading } = useLoading();
  const { miniSidenav, direction, layout, sidenavColor } = controller;
  const [onMouseEnter, setOnMouseEnter] = useState(false);
  const { pathname } = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    // Store the navigate function globally
    setNavigator(navigate);
  }, [navigate]);

  const handleOnMouseEnter = () => {
    if (miniSidenav && !onMouseEnter) {
      setMiniSidenav(dispatch, false);
      setOnMouseEnter(true);
    }
  };

  const handleOnMouseLeave = () => {
    if (onMouseEnter) {
      setMiniSidenav(dispatch, true);
      setOnMouseEnter(false);
    }
  };

  useEffect(() => {
    document.body.setAttribute("dir", direction);
  }, [direction]);

  useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
  }, [pathname]);

  const getRoutes = (allRoutes) =>
    allRoutes.map((route) => {
      if (route.collapse) {
        return getRoutes(route.collapse);
      }
      if (route.route) {
        return (
          <Route
            exact
            path={route.route}
            element={route.component}
            key={route.key}
          />
        );
      }

      return null;
    });

  return (
    <>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        {circleLoading && <Spinner fullScreen />}

        {layout === "dashboard" && pathname!== "/cspua" && pathname !== "/unknown-page" &&(
          <>
            <Sidenav
              color={sidenavColor}
              brand={miniSidenav ? null : logo}
              // brandName="Keelis"
              routes={routes}
              onMouseEnter={handleOnMouseEnter}
              onMouseLeave={handleOnMouseLeave}
            />
          </>
        )}

        <Routes>
          {getRoutes(routes)}
          <Route path="*" element={<Navigate to="/unknown-page" />} />
        </Routes>
      </ThemeProvider>
    </>
  );
}

export default App;
